export default __webpack_public_path__ + "static/media/Recommended_Blocks4All.971ac163.pdf";